import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../contexts/AppContext';

import Link from '../components/Link';
import { videoJson } from '../data/Data';

const Renew = () => {
  return (
    <div className="page-container w-full h-full bg-cover bg-center relative flex justify-center items-center">
      <div className='flex justify-center items-start flex-wrap' style={{width:'60vw'}}>
        <Link to={'/video/renew1'} style={{padding:"1vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/renew3.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Get To Know Electric Vehicles</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', top:"11.3vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
        <Link to={'/video/renew2'} style={{padding:"1vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/renew2.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title leading-6 mt-2'>Do You Have Questions About<br />Electic Vehicles?</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', top:"11.3vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
        <Link to={'/video/renew3'} style={{padding:"1vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/renew1.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Get To Know Rebates</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', top:"11.3vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
      </div>
      <Link to={'/home'}>
        <img src='./assets/exit.png' className='absolute bottom-10 right-10' style={{width:'5vw'}} alt='Back Button' />
      </Link>
    </div>
  )
}

export default Renew